import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notification"
export default class extends Controller {
  static values = {
    dismissAfter: { type: Number, default: 30000 }
  }

  connect() {
    this.startTimeout();
    this.element.addEventListener("mousedown", this.dragStart.bind(this));
    this.element.addEventListener("touchstart", this.dragStart.bind(this), { passive: true });
  }

  disconnect() {
    this.stopTimeout();
  }

  // Oculta la notificación
  hide() {
    this.stopTimeout();
    this.element.style.transition = "opacity 0.3s ease-out, transform 0.3s ease-out";
    this.element.classList.add('opacity-0');
    
    if (this.isDragging) {
      const direction = Math.sign(this.currentX - this.startX);
      this.element.style.transform = `translateX(${direction * 100}%)`;
    }

    // La notificación se eliminará del DOM después de la animación de 300ms
    setTimeout(() => {
      this.element.remove();
    }, 300);
  }

  // Inicia el temporizador para auto-ocultar
  startTimeout() {
    this.stopTimeout(); // Asegura que no haya múltiples temporizadores
    this.timeout = setTimeout(() => this.hide(), this.dismissAfterValue);
  }

  // Detiene el temporizador
  stopTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  // --- Lógica de Arrastre ---

  dragStart(event) {
    this.isDragging = true;
    this.startX = event.pageX || event.touches[0].pageX;
    this.currentX = this.startX;
    this.stopTimeout(); // Detiene el temporizador al interactuar

    this.element.style.transition = ""; // Quita la transición para un arrastre suave

    this.dragMove = this.dragMove.bind(this);
    this.dragEnd = this.dragEnd.bind(this);

    window.addEventListener("mousemove", this.dragMove);
    window.addEventListener("touchmove", this.dragMove);
    window.addEventListener("mouseup", this.dragEnd);
    window.addEventListener("touchend", this.dragEnd);
  }

  dragMove(event) {
    if (!this.isDragging) return;
    this.currentX = event.pageX || event.touches[0].pageX;
    const deltaX = this.currentX - this.startX;
    this.element.style.transform = `translateX(${deltaX}px)`;
  }

  dragEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;

    const deltaX = this.currentX - this.startX;
    const threshold = this.element.offsetWidth * 0.5; // 50% del ancho

    if (Math.abs(deltaX) > threshold) {
      this.hide();
    } else {
      // Vuelve a la posición original
      this.element.style.transition = "transform 0.3s ease-out";
      this.element.style.transform = "translateX(0)";
      this.startTimeout(); // Reinicia el temporizador si no se descarta
    }

    // Limpia los listeners globales
    window.removeEventListener("mousemove", this.dragMove);
    window.removeEventListener("touchmove", this.dragMove);
    window.removeEventListener("mouseup", this.dragEnd);
    window.removeEventListener("touchend", this.dragEnd);
  }
}
